import boardActionTypes from "./board.types";
import { checkForBingo, getShuffledBoard } from "./board.utils";

const INITIAL_STATE = {
    // Skapa en array med 25 element (0-24)
    board: getShuffledBoard(false),
    // Skapa en array med 25 false
    checked: new Array(25).fill(false),
    // Skapa en array med 25 nollor
    bingo: new Array(25).fill(0),
    extreme: false
};

const boardReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case boardActionTypes.SHUFFLE_BOARD:
            return {
                ...state,
                board: getShuffledBoard(state.extreme),
                checked: new Array(25).fill(false),
                bingo: new Array(25).fill(0)
            };

        case boardActionTypes.CHECK_BLOCK:
            const index = action.payload;
            // Skapa en kopia av checked-arrayen för att inte mutera state direkt (immutability)
            const newChecked = [...state.checked];
            newChecked[index] = !newChecked[index];

            const newBingo = checkForBingo(newChecked, index);

            return {
                ...state,
                checked: newChecked,
                bingo: newBingo
            };

        case boardActionTypes.TOGGLE_EXTREME:
            const nextExtreme = !state.extreme;
            return {
                ...state,
                extreme: nextExtreme,
                board: getShuffledBoard(nextExtreme),
                checked: new Array(25).fill(false),
                bingo: new Array(25).fill(0)
            };

        default:
            return state;
    }
};

export default boardReducer;